export const API_Endpoints = {
  auth: {
    LOGIN: "/api/login",
    SIGNUP: "/api/register",
    SEND_EMAIL: "/api/send-email",
    RESET_PASSWORD: "/api/reset-password",
    UPDATE_USER_PROFILE: "/api/update-profile",
    ACTIVATE_USER_ACCOUNT: "/api/active-account",
    RESEND_EMAIL: "/api/resend-email",
  },
  Admin: {
    GET_USERS: "/admin/api/get-users",
    ADD_CATEGORY: "/admin/api/categories",
    GET_USER_DETAIL: "/admin/api/edit-profile",
    GET_CATEGORIES: "/admin/api/categories",
    GET_CATEGORY_DETAIL: "/admin/api/categories",
    DELETE_USER: "/admin/api/users",
    GET_AUCTIONS: "/admin/api/get-auctions",
    CHANGE_USER_STATUS: "/admin/api/users/status",
    EDIT_AUCTIONS: "/admin/api/auction",
    GET_AUCTION_DETAILS: "/admin/api/auctions",
    UPDATE_USER_PROFILE: "/admin/api/update-profile",
    DELETE_AUCTIONS : "/admin/api/auctions"
  },
  Users: {
    USER_DETAILS: "/api/user-detail",
  },
  Categories: { GET_CATEGORIES: "/api/categories" },
  Auctions: {
    CREATE_AUCTION: "/api/auctions",
    GET_AUCTIONS: "/api/auctions",
    GET_AUCTION_DETAIL: "/api/auctions",
    CURRENT_AUCTIONS: "/api/user-auctions",
    PREVIOUS_AUCTIONS: "/api/user-auctions",
    DELETE_AUCTION: "/api/auctions",
    SEARCH_AUCTIONS: "/api/search-auctions",
    GET_REGIONS: "/api/get-region",
    EDIT_AUCTION: "/api/auctions",
  },
};
